import React from "react";
import { useSelector } from "react-redux";
import { IStore } from "@/redux/defaultStore";
import { useNavigate } from "react-router-dom";
import styles from "./ActionCards.module.scss";

interface FuelUpProgressCardProps {
    currentFuel?: string;
    nextReward?: string;
}

/**
 * FuelUpProgressCard - Placeholder for upcoming Fuel gamification feature
 * Will track fuel loading/holding progress and rewards
 */
const FuelUpProgressCard: React.FC<FuelUpProgressCardProps> = () => {
    const navigate = useNavigate();
    const fuelBalance = useSelector((store: IStore) => store.metaStore.fuelBalance);

    // Placeholder data for future feature
    const fuelCells = 0; // Will track fuel cells collected
    const targetCells = 6; // Target for next reward
    const nextBoost = "2X XP Boost"; // Next reward tier

    const handleLoadFuel = () => {
    // Navigate to fuel loading page
        navigate("/load-fuel");
    };

    return (
        <div
            className="stat-card"
            onClick={handleLoadFuel}
            style={{
                cursor: "pointer",
                backgroundImage: `url(${import.meta.env.VITE_CDN_URL}/images/card-bck5.png)`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                border: "1px solid rgba(241, 22, 29, 0.3)",
                position: "relative",
            }}
        >
            <div style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(0, 0, 0, 0.4)",
                borderRadius: "inherit",
            }}></div>
            <div style={{ position: "relative", zIndex: 1 }}>
                <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "0.5rem" }}>
                    <img
                        src={`${import.meta.env.VITE_CDN_URL}/images/FUEL.webp`}
                        alt="Fuel"
                        style={{
                            width: "24px",
                            height: "24px",
                            objectFit: "contain",
                        }}
                    />
                    <h4 style={{ color: "white", textShadow: "0 2px 4px rgba(0, 0, 0, 0.9)", fontWeight: "700", letterSpacing: "0.5px", margin: 0 }}>FUEL UP</h4>
                </div>
                <div className="stat-value" style={{ color: "#f1161d", textShadow: "0 2px 4px rgba(0, 0, 0, 0.9)", fontWeight: "700", fontSize: "1.1rem" }}>ADVENTURE</div>
                <div className="stat-subtitle" style={{ color: "rgba(255, 255, 255, 0.95)", textShadow: "0 1px 2px rgba(0, 0, 0, 0.9)", fontWeight: "500" }}>Coming Soon</div>
            </div>
        </div>
    );
};

export default FuelUpProgressCard;